<template>
  <div
    class="header-box model"
    :style="{
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius,
    }"
  >
    <div class="left">
      <img class="icon" alt="" />
      <span class="title">{{ title }}</span>
    </div>
    <div class="right">
      <template v-for="(item, index) in topBtns">
        <el-button v-reClick 
          v-if="item.show==false? false : true"
          :key="index"
          :plain="item.plain || true"
          :type="item.type || 'primary'"
          :icon="item.icon || ''"
          :size="item.size || 'medium'"
          :disabled="item.disabled || false"
          @click="topOperation(item.text,item.event)"
          >{{ item.text }}</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EXHeader',
  props: {
    title: String,
    showTable: Function,
    saveForm: Function,
    borderRadius: {
      type: String,
      default: "8px"
    },
    topBtns: {
      type: Array,
      default: () => {
        return [
          {
            text: "返回",
            type: "primary",
            size: "medium",
            plain: true,
          },
        ];
      },
    },
  },
  data(){
    return {
    }
  },
  methods: {
    topOperation(text,event) {
      if (text == "返回") {
        this.$emit("showTable");
      }else if(text == "保存"){
        this.$emit('saveForm')
      }else if(text == "下载"){
        this.$emit('download')
      }else{
        if(event && typeof event === "function"){
          event()
        }
      }
    }  
  },
  computed:{
    headerWidth:{
      get(){
        let width = ''
        if(this.$store.state.app.sidebar.opened){
          width = 'calc(100% - 0.16rem - 0.16rem - 2.62rem)'
        } 
        if(!this.$store.state.app.sidebar.opened){
          width = 'calc(100% - 0.16rem - 0.16rem - .5rem)'
        } 
        return width
      },
      set(){},
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.header-box {
  width: 100%;
  // width: calc(100% - 0.16rem - 0.16rem - 2.53rem);
  height: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  .left {
    display: flex;
    align-items: center;
    .icon {
      width: 0.18rem;
      height: 0.18rem;
      margin-right: 0.08rem;
      @include head_icon('detailHeader.png');
    }
    .title {
      // font-size: 0.18rem;
      font-weight: bold;
      @include font_color($font-colorD);
    }
  }
}
/deep/ .el-button {
  min-width: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/EXDetail/EXHeader.vue